import styled from "styled-components";

export const PropLabel = styled.span`
  user-select: none;
  flex: 1;
  font-size: 12px;
  color: #252525;
`;

export const PropLabelFlex = styled(PropLabel)`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const PropListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0;
`;

export const ActiveLabel = styled.span`
  font-size: 8px;
  padding: 2px 4px;
  border-radius: 1px;
  line-height: 1.2em;
  letter-spacing: 0.025em;

  ${({active}) => active ? `
    background-color: #3BD07824;
    color: #0F9245;
  ` : `
    background-color: #FF525214;
    color: #FF5252;
  `}
`;
